<template>
  <div class="notice">
		<div class="topCar">
			<div class="tip">{{titleName}}</div>
			<div class="tip-r">
				<!-- {{list[0]}} -->
				<span v-if="sign == 1 || sign == 3" class="first" >
					<span @click="toDetail(list[0])" v-if='list[0]' :title="list[0].title">
						{{list[0].title?list[0].title.substring(0,8):''}}
						<span v-if="list[0].title&&list[0].title.length>8">...</span>
					</span>
				</span>
				<span v-if="sign == 2" class="first">
					<span @click="toDetail(list[0])" v-if='list[0]' :title="list[0].compilationTitle">
						{{list[0].compilationTitle?list[0].compilationTitle.substring(0,8):''}}
						<span v-if="list[0].compilationTitle&&list[0].compilationTitle.length>8">...</span>
					</span>
				</span>
				<span v-if="sign == 4" class="first">
					<span @click="toDetail(list[0])" v-if='list[0]' :title="list[0].title">
						{{list[0].title?list[0].title.substring(0,8):''}}
						<span v-if="list[0].title&&list[0].title.length>8">...</span>
					</span>
				</span>
				<span style="color: #E61F26;font-size: 0.14rem;cursor: pointer;" @click="moreContent">更多> </span>
			</div>
			
		</div>
		
		<div class="conCar">
			<div v-for="(item,index) in list" :key="index" >
				<div v-if="list.length>1" @click="toDetail(item)">
					<div class="conCarList" v-if='!(index==0)'>
						<div class="rol"></div>
						<!-- <div v-if="index!=0" style="font-size:12px">{{item.publishTime?item.publishTime.split(' ')[0]:''||item.pubTime?item.pubTime.split(' ')[0]:''}}-</div> -->
						<div v-if="sign == 1 || sign == 3" :title="item.title">
							{{item.title.substring(0,15)}}
							<span v-if="item.title.length>15">...</span>				
						</div>
						
						<div v-if="sign == 2" :title="item.compilationTitle">
							{{item.compilationTitle.substring(0,15)}}
							<span v-if="item.compilationTitle.length>15">...</span>
						</div>
						
						<div v-if="sign == 4" :title="item.title">
							{{item.title.substring(0,15)}}
							<span v-if="item.title.length>15">...</span>
						</div>
						
					</div>
				</div>
				
			</div>
		</div>

  </div>
</template>

<script>

export default {
  components: {

  },
  
  props: ['titleName','sign'],
  data() {
		return {
			list:[],
			
			
		};
  },
  
  mounted() {
	 if(this.sign == 1){
		 this.getCampus()
	 }else if(this.sign == 2){
		this.getNotice()
	 }else if(this.sign == 3){
		this.getCampus_two()
	 }else if(this.sign == 4){
		this.getSocial() 
	 }
	
  },
  
  methods: {
	  gethypertext(str){
		  if(str == null){
		  		return "";
		  }
		  
		  var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "")
		              .replace(/&ldquo;/gi, "").replace(/\n/gi, "");
		  // str = str.substring(0,15);
		  return str;
	  },
	  
	  moreContent(){
		  if(this.sign == 1 || this.sign == 3){
			  this.$router.push({ path: '/pressrelease', query: {type:1} });
		  }else if(this.sign == 2){
			  this.$router.push({ path: '/pressrelease', query: {type:2} });
		  }else if(this.sign == 4){
			  this.$router.push({ path: '/pressrelease', query: {type:9} });
		  }
		  
	  },
	  
	  //跳转详情
	  toDetail(item){
		  if(this.sign == 1 || this.sign == 3){
		  		this.$router.push({ path: '/pressrelease/detail', query: {id:item.id,type:1} });
		  }else if(this.sign == 2){
		  		this.$router.push({ path: '/pressrelease/detail', query: {id:item.id,type:2} });
		  }else if(this.sign == 4){
		  		this.$router.push({ path: '/pressrelease/detail', query: {id:item.id,type:9} });
		  }  	
	  },
	  
	  //校园情报站
	  getCampus(){
			this.$get(`web/info/campus?pageSize=7&pageNo=1`).then(res=>{
				  if(res.success){
						this.list=res.result.records
				  }
			})
	  },  
	  getCampus_two(){
			this.$get(`web/info/campus?pageSize=16&pageNo=1`).then(res=>{
				  if(res.success){
						this.list=res.result.records
				  }
			})
	  },
	  
	  //汇编文章
	  getNotice(){
			this.$get(`web/compilation/ypCompilation/list?pageSize=7&pageNo=1`).then(res=>{
				  if(res.success){
						this.list=res.result.records
				  }
			})
	  },
	  
	  //社会情报站
	  getSocial(){
			this.$get(`web/info/society?pageSize=16&pageNo=1`).then(res=>{
				  if(res.success){
						this.list=res.result.records
				  }
			})
	  },
	  
	  
	  
  }
};
</script>

<style scoped lang="scss">
	.notice{
		height: 100%;
		// border: 1px solid red;
		
		.topCar{
			margin: 0.1rem 0.2rem 0 0.2rem;
			border-bottom: 0.01rem solid #ededed;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.tip{
				width: 1.16rem;
				height: 0.41rem;
				background: #E70012;
				font-size: 0.16rem;
				color: #FFFFFF;
				line-height: 0.41rem;
				text-align: center;
				cursor: pointer;
			}
			.tip-r{
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: calc(100% - 1.26rem);
			}
			.first{
				cursor: pointer;
				display: inline-block;
				font-size: 0.14rem;
				text-align: left;
				color: #E70012;
			}
		}
		
		.conCar{
			margin: 0rem 0.2rem 0 0.2rem;
			.conCarList{
				cursor: pointer;
				height: 0.33rem;
				line-height: 0.33rem;
				font-size: 0.16rem;
				display: flex;
				align-items: center;
				.rol{
					background: #E70012;
					border-radius: 50%;
					height: 0.05rem;
					width: 0.05rem;
					margin-right: 0.05rem;
				}
			}
			.conCarList:hover{ color:#E70012; }
			
		}
		
		
	}
	
</style>
